import { render } from "./LaunchButtonComponent.vue?vue&type=template&id=061e2efa&scoped=true&ts=true"
import script from "./LaunchButtonComponent.vue?vue&type=script&lang=ts"
export * from "./LaunchButtonComponent.vue?vue&type=script&lang=ts"

import "./LaunchButtonComponent.vue?vue&type=style&index=0&id=061e2efa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061e2efa"]])

export default __exports__